import axios from 'axios';
import jwt_decode from 'jwt-decode';
import UserPreferenceSingleton from './userPreferenceSingleton';
import { captureException } from '../services/logService';

interface JwtPayload {
  deviceId?: string;
  exp: number;
}

export const setupToken = () => {
  const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
  const { access_token } = userDetails || {};

  if (access_token) {
    const decoded: JwtPayload = jwt_decode(access_token);
    if (!decoded.deviceId) return false;
    const currentTime = Date.now() / 1000;
    if (decoded.exp > currentTime) {
      setAuthToken(access_token);
      return access_token;
    }
  }
  return false; // if no token or expired token, return false
};

export const decodeFirebaseCustomToken = (workspaceId: string) => {
  try {
    const localCustomToken = UserPreferenceSingleton.getInstance().getFirebaseCustomToken(workspaceId);
    if (!localCustomToken || typeof localCustomToken !== 'string') {
      return;
    }
    const decoded: JwtPayload = jwt_decode(localCustomToken);
    const currentTime = Date.now() / 1000;
    if (decoded.exp > currentTime) {
      return localCustomToken;
    }
    return undefined;
  } catch (e) {
    console.error('Error decoding Firebase custom token', e);
    return null;
  }
};

export const saveToken = (access_token: string) => {
  setAuthToken(access_token);
};

export const clearToken = () => {
  UserPreferenceSingleton.getInstance().clearStoredUserData();
  clearAuthToken();
};

export const setWorkspaceIdInAxios = (workspace_id: string) => {
  try {
    axios.defaults.headers.common['workspace_id'] = workspace_id;
  } catch (e) {
    captureException(e);
  }
};

// header methods
const setAuthToken = (token: string) => {
  try {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  } catch (e) {
    captureException(e);
  }
};

const clearAuthToken = () => {
  delete axios.defaults.headers.common['Authorization'];
  delete axios.defaults.headers.common['workspace_id'];
};
